


$(document).ready(() => {
	const partnerSlider = new Swiper(".partner-slider .swiper", {
		slidesPerView: 3.5,
		spaceBetween: 16,
		loop: true,
		speed: 4000,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".partner-slider .swiper-btn-next",
			prevEl: ".partner-slider .swiper-btn-prev",
		},
		breakpointsInverse: true,
		breakpoints: {
			576: {
				slidesPerView: 4.5,
			},
			768: {
				slidesPerView: 5.5,
			},
			1024: {
				slidesPerView: 8,
				spaceBetween: 24,
			},
		},
	});

	const homeEnviromentSlider = new Swiper(".home-enviroment-slider .swiper", {
		slidesPerView: "auto",
		loop: true,
		speed: 5000,
		preloadImages: false,
		lazy: true,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
		},
	});

	const homeFeaturedSlider = new Swiper(".home-featured-slider .swiper", {
		slidesPerView: "auto",
		speed: 700,
		freeMode: true,
	});
	const homeTextAmenitiesSlider = new Swiper(".home-amenities-text", {
		slidesPerView: "auto",
		speed: 700,
		spaceBetween: 24,
		watchSlidesProgress: true,
		slideToClickedSlide: true,
		watchSlidesVisibility: true,
		observer: true,
		observeParents: true,
		loop: true,
		centeredSlides: true,
		init: false,
		direction: "horizontal",
		breakpointsInverse: true,
		breakpoints: {
			1024: {
				slidesPerView: 7,
				direction: "vertical",
				spaceBetween: 0
			},
		},
	});

	const homeImageAmenitiesSlider = new Swiper(".home-amenities-slider .swiper", {
		slidesPerView: "auto",
		speed: 700,
		observer: true,
		observeParents: true,
		loop: true,
		pagination: {
			el: ".home-amenities-slider .swiper-pagination",
			clickable: true
		},
		navigation: {
			nextEl: ".home-amenities-slider .swiper-btn-next",
			prevEl: ".home-amenities-slider .swiper-btn-prev",
		},
		mousewheel: true,
		init: false,
		breakpoints: {
			1024: {
				centeredSlides: true,
				spaceBetween: 16,
			}
		},
		// thumbs: {
		// 	swiper: homeTextAmenitiesSlider
		// }

	});

	homeImageAmenitiesSlider.on("slideChange", () => {
		// homeTextAmenitiesSlider.slideToLoop(homeImageAmenitiesSlider.realIndex);
		updateBulletClasses(homeImageAmenitiesSlider)
	});

	homeImageAmenitiesSlider.on("init", () => {
		updateBulletClasses(homeImageAmenitiesSlider)
	})

	homeTextAmenitiesSlider.on("slideChange", () => {
		const activeIndex = homeTextAmenitiesSlider.activeIndex;
		const nextSlide = homeTextAmenitiesSlider.slides[activeIndex + 1];
		const prevSlide = homeTextAmenitiesSlider.slides[activeIndex - 1];
		const nextNextSlide = homeTextAmenitiesSlider.slides[activeIndex + 2];
		const prevPrevSlide = homeTextAmenitiesSlider.slides[activeIndex - 2];
		const nextNextNextSlide = homeTextAmenitiesSlider.slides[activeIndex + 3];
		const prevPrevPrevSlide = homeTextAmenitiesSlider.slides[activeIndex - 3];

		$(homeTextAmenitiesSlider.slides).removeClass("next prev next-next prev-prev next-next-next prev-prev-prev");


		if (nextSlide) {
			nextSlide.classList.add("next");
		}
		if (prevSlide) {
			prevSlide.classList.add("prev");
		}
		if (nextNextSlide) {
			nextNextSlide.classList.add("next-next");
		}
		if (prevPrevSlide) {
			prevPrevSlide.classList.add("prev-prev");
		}
		if (nextNextNextSlide) {
			nextNextNextSlide.classList.add("next-next-next");
		}
		if (prevPrevPrevSlide) {
			prevPrevPrevSlide.classList.add("prev-prev-prev");
		}

	});

	homeTextAmenitiesSlider.on("init", () => {
		const activeIndex = homeTextAmenitiesSlider.activeIndex;
		const nextSlide = homeTextAmenitiesSlider.slides[activeIndex + 1];
		const prevSlide = homeTextAmenitiesSlider.slides[activeIndex - 1];
		const nextNextSlide = homeTextAmenitiesSlider.slides[activeIndex + 2];
		const prevPrevSlide = homeTextAmenitiesSlider.slides[activeIndex - 2];
		const nextNextNextSlide = homeTextAmenitiesSlider.slides[activeIndex + 3];
		const prevPrevPrevSlide = homeTextAmenitiesSlider.slides[activeIndex - 3];

		if (nextSlide) {
			nextSlide.classList.add("next");
		}
		if (prevSlide) {
			prevSlide.classList.add("prev");
		}
		if (nextNextSlide) {
			nextNextSlide.classList.add("next-next");
		}
		if (prevPrevSlide) {
			prevPrevSlide.classList.add("prev-prev");
		}
		if (nextNextNextSlide) {
			nextNextNextSlide.classList.add("next-next-next");
		}
		if (prevPrevPrevSlide) {
			prevPrevPrevSlide.classList.add("prev-prev-prev");
		}

	});

	try {
		homeTextAmenitiesSlider.init();
		homeImageAmenitiesSlider.init();

		homeImageAmenitiesSlider.controller.control = homeTextAmenitiesSlider;
		homeTextAmenitiesSlider.controller.control = homeImageAmenitiesSlider;
	} catch (error) {

	}


	// $(".home-amenities-text .item").each((index, element) => {
	// 	const $this = $(element);
	// 	const $thisIndex = $this.data("index");
	// 	$this.on("click", () => {
	// 		homeImageAmenitiesSlider.slideToLoop($thisIndex);
	// 	});
	// });

	const about2Slider = new Swiper(".about-2-slider .swiper", {
		slidesPerView: "auto",
		speed: 700,
	});

	const progressTopSlider = new Swiper(".progress-slider-top .swiper", {
		slidesPerView: "auto",
		speed: 700,
	});

	const progressBottomSlider = new Swiper(".progress-slider-bottom .swiper", {
		slidesPerView: "auto",
		speed: 700,
	});

	try {
		progressTopSlider.controller.control = progressBottomSlider;
		progressBottomSlider.controller.control = progressTopSlider;
	} catch (error) {

	}


});

function updateBulletClasses(swiperInstance) {
	// 1. Lấy danh sách tất cả các bullets
	// Lưu ý: swiperInstance.pagination.bullets là một mảng các phần tử DOM
	const bullets = Array.from(swiperInstance.pagination.bullets);
	// 2. Tên class custom
	const prevClass = 'swiper-pagination-bullet-active-prev';
	const nextClass = 'swiper-pagination-bullet-active-next';

	// 3. Reset: Xóa các class prev/next cũ khỏi TẤT CẢ bullet trước khi tính toán lại
	bullets.forEach(bullet => {
		$(bullet).removeClass(prevClass, nextClass);
	});

	// 4. Lấy index của slide hiện tại
	const activeIndex = swiperInstance.realIndex;
	// 5. Xử lý bullet PREV (Liền trước)
	// Kiểm tra xem có bullet ở vị trí [activeIndex - 1] không
	if (bullets[activeIndex - 1]) {
		$(bullets[activeIndex - 1]).addClass(prevClass);
	}

	// 6. Xử lý bullet NEXT (Liền sau)
	// Kiểm tra xem có bullet ở vị trí [activeIndex + 1] không
	if (bullets[activeIndex + 1]) {
		$(bullets[activeIndex + 1]).addClass(nextClass);
	}
}

window.updateBulletClasses = updateBulletClasses;